// web/src/components/RecommendationFeed.tsx
import { RecCard, type RecCardProps } from "./RecCard";
import type { Verb } from "./VerbBadge";

export type RecRow = Omit<RecCardProps, "onAction" | "onUnsnooze">;

export interface RecommendationFeedProps {
  recs: RecRow[];
  onAction: (rec_id: string, input: { status: "snoozed" | "done" | "dismissed"; snooze_days?: 7 | 14 }) => Promise<void>;
  onUnsnooze: (rec_id: string) => Promise<void>;
  showSuppressed: boolean;
  onToggleSuppressed: () => void;
  suppressedCount: number;
}

const ORDER: Verb[] = ["scale", "throttle", "refresh_creative", "kill"];

const HEADER_COLOR: Record<Verb, string> = {
  scale: "#5fb37a", throttle: "#d9a64a", refresh_creative: "#5b9be8", kill: "#d96057",
};

const HEADER_LABEL: Record<Verb, string> = {
  scale: "▲ Scale", throttle: "▼ Throttle",
  refresh_creative: "↻ Refresh creative", kill: "✕ Kill",
};

export function RecommendationFeed(props: RecommendationFeedProps) {
  const groups: Record<Verb, RecRow[]> = {
    scale: [], throttle: [], refresh_creative: [], kill: [],
  };
  for (const r of props.recs) groups[r.verb].push(r);

  const total = props.recs.length;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontSize: 11, color: "#7a808c", textTransform: "uppercase" }}>
          Recommendations · {total}
        </div>
        {props.suppressedCount > 0 && (
          <button type="button" onClick={props.onToggleSuppressed} style={{ fontSize: 11 }}>
            {props.showSuppressed ? `Hide suppressed` : `Show ${props.suppressedCount} suppressed`}
          </button>
        )}
      </div>

      {total === 0 && (
        <div style={{ fontSize: 12, color: "#7a808c", padding: "16px 0" }}>
          No open recommendations for this window. All ad sets are performing within thresholds
          or are suppressed.
        </div>
      )}

      {ORDER.map((verb) => {
        const items = groups[verb];
        if (items.length === 0) return null;
        return (
          <div key={verb} style={{ marginBottom: 14 }}>
            <div style={{
              fontSize: 11, color: HEADER_COLOR[verb], fontWeight: 600,
              textTransform: "uppercase", marginBottom: 6,
            }}>
              {HEADER_LABEL[verb]} · {items.length}
            </div>
            {items.map((r) => (
              <RecCard
                key={r.rec_id}
                {...r}
                onAction={(input) => props.onAction(r.rec_id, input)}
                onUnsnooze={() => props.onUnsnooze(r.rec_id)}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}
